export const BLACK = '#000000'
export const DARK = '#1D1D1D'
export const BODY = '#151515'
export const LIGHT = '#FFEFCE'

export default {
  BLACK,
  DARK,
  BODY,
  LIGHT
}
